import { Box, IconButton, alpha } from '@mui/material'
import { Search } from '@mui/icons-material'
import { colors } from '@/theme/colors.theme'

import InputSearchFieldComponent from './input-search-field.component'
import useSearchBar from './use-search-bar.hook'

const SearchBarComponent = () => {
  const {
    filterType,
    filterValue,
    activeSearch,
    handleChangeFilterType,
    handleSetActiveSearch,
    handleChangeSearchField,
    handleEnterSearch,
  } = useSearchBar()

  return (
    <Box
      sx={{
        paddingRight: 2,
        marginRight: 4,
        borderRight: `1px solid ${alpha(colors.white, 0.1)}`,
        height: '40px',
        mt: '14px',
        pt: '2px',
      }}
    >
      {activeSearch ? (
        <InputSearchFieldComponent
          filterType={filterType}
          filterValue={filterValue}
          handleSetActiveSearch={handleSetActiveSearch}
          handleChangeFilterType={handleChangeFilterType}
          handleChangeSearchField={handleChangeSearchField}
          handleEnterSearch={handleEnterSearch}
        />
      ) : (
        <IconButton onClick={handleSetActiveSearch} size="medium">
          <Search fontSize="inherit" />
        </IconButton>
      )}
    </Box>
  )
}

export default SearchBarComponent
